export default (items) => {

    let sortedItems = [];

    if(items && items.length){
        sortedItems = items.sort((item1, item2) => {
        if(item1.location < item2.location)
            return -1;
        if(item1.location > item2.location)
            return 1;
        if(item1.id < item2.id)
            return -1;
        return 1;
        });
    }

    const grouped = [];
    let ndx = -1;
    let crtLoc = '';

    for(let i=0;i<sortedItems.length;i++){
        let loc = sortedItems[i].location;
        if(loc !== crtLoc){
            ndx++;
            crtLoc = loc;
            grouped[ndx] = [];
        }
        if(ndx > -1)
            grouped[ndx].push(sortedItems[i]);
    }
    return grouped;
}


// WEBPACK FOOTER //
// ./src/selectors/groupeditems.js